<template>
  <div>
  <!-- <div class="search-con">
    <el-select clearable placeholder="请选择课程" style="width: 340px" v-model="belongCourseTitle" @change="clearSearch">
      <el-option :label="value.kcName" :value="value.id" v-for="(value, index) in courseList" :key="index"> </el-option>
    </el-select>
    <el-select clearable placeholder="请选择题型" v-model="questionType" @change="clearSearch">
      <el-option label="全部" value="-1"></el-option>
      <el-option label="单选" value="0"></el-option>
      <el-option label="多选" value="1"></el-option>
      <el-option label="判断" value="2"></el-option>
    </el-select>
    <el-select clearable placeholder="请选择错题次数" v-model="wrongAnswersNumber" @change="clearSearch">
      <el-option label="1-10次" value="1-10"></el-option>
      <el-option label="11-20次" value="11-20"></el-option>
      <el-option label="20次以上" value="20"></el-option>
    </el-select>
  </div> -->
  <div class="question-con" v-loading="loading" v-if="questionList.length > 0">
    <div v-for="(item, index) in questionList" :key="index">
   
      <question-view :isSubmit="isSubmit" :item="item" @play-video="playVideo" knowledge-class-type="3">
       
        <div class="showError">
          本题已做
          <span class="tag1">{{ item.answersNumber }}</span>
          次 做错
          <span class="tag2">{{ item.wrongAnswersNumber }}</span>
          次 做对
          <span class="tag3">{{ item.correctAnswersNumber }}</span>
          次
        </div>
      </question-view>
    </div>
  </div>
  <el-empty description="暂无试题" v-else style="margin-top: 100px"></el-empty>
  <div class="btn-con" v-if="questionList.length > 0">
    <el-button class="reset-btn" @click="resetSubmit" v-if="isSubmit">重新答题</el-button>
    <el-button :loading="subLoading" @click="clickSubmit" v-else>完成练习</el-button>
    <el-button :loading="loading" class="go-btn" @click="goSubmit">继续答题</el-button>
  </div>

 </div>
</template>

<script>
import QuestionView from "./QuestionView.vue";
import { HomeClient } from "@/api/home";

export default {
  name: 'MyWrongQuestions',
  components: {
    QuestionView
  },
  data() {
    return {
      questionType: null,
      belongCourseTitle: "",
      wrongAnswersNumber: "",
      pageNum: 1,
      pageSize: 10,
      isSubmit: false,
      loading: false,
      subLoading: false,
      questionList: [],
      courseList: [],
      // 知识点
      videoShow: false, // 视频显示
      videoInfo: {}, // 视频信息
      isCc: false, // 是否为cc直播回放视频
      ccPlayerRef: null
    };
  },
  created() {
    this.getUserWrongTopic();
  },
  methods: {
    /* 查询列表 */
    getUserWrongTopic() {
      this.loading = true;
      this.isSubmit = false;
      this.questionList = [];
      const homeClient = new HomeClient();
      homeClient
        .getUserWrongTopic(
         {pageNum: this.pageNum,
          pageSize: this.pageSize,
          belongCourseTitle: this.belongCourseTitle ? this.belongCourseTitle : undefined,
          questionType: this.questionType ? this.questionType : "-1",
          wrongAnswersNumber: this.wrongAnswersNumber ? this.wrongAnswersNumber : undefined}
        )
        .then((res) => {
          if (res.code == 0) {
            let arr=[]
            res.data.rows.forEach(e => {
              if(e.questionType == 0 || e.questionType == 1|| e.questionType == 2){
                arr.push(e)
              }
             
            });
            this.questionList = arr;
            this.checkBoxChangeArray(this.questionList);
          }
          this.loading = false;
        });
    },
    // 多选题处理  字符串转换成数组  用在页面多选框渲染
    checkBoxChangeArray(list) {
      list.forEach((item) => {
        if (item.questionType == 1 || item.questionType == 6) {
          item.userAnswer = item.userAnswer ? item.userAnswer.split(",") : [];
        } else if (item.questionType == 5 && item.subTopicList) {
          this.checkBoxChangeArray(item.subTopicList);
        } else {
          item.userAnswer = item.userAnswer ? item.userAnswer : "";
        }
        if (!item.questionOptionList) {
          item.questionOptionList = JSON.parse(item.questionOption);
        }
      });
    },
    // 多选题处理  数组转换成字符串  用在提交
    checkBoxChangeString(list) {
      list.forEach((item) => {
        if (item.questionType == 1 || item.questionType == 6) {
          item.userAnswer = item.userAnswer.sort().toString();
        } else if (item.questionType == 5 && item.subTopicList) {
          this.checkBoxChangeString(item.subTopicList);
        }
      });
      return list;
    },
    /* 点击完成练习 */
    clickSubmit() {
      const obj = this.checkBoxChangeString(JSON.parse(JSON.stringify(this.questionList)));
      this.updateUserWrongTopic(obj);
      this.isSubmit = true;
      this.backTop();
    },
    /* 点击继续答题 */
    goSubmit() {
      this.isSubmit = false;
      this.pageNum++;
      this.getUserWrongTopic();
      this.backTop();
    },
    /* 提交 */
    updateUserWrongTopic(obj) {
      this.subLoading = true;
      const homeClient = new HomeClient();
      homeClient.updateUserWrongTopic(obj).then((res) => {
        this.subLoading = false;
        this.questionList = res.data;
        this.checkBoxChangeArray(this.questionList);
      });
    },
    clearSearch() {
      this.isSubmit = false;
      this.pageNum = 1;
      this.getUserWrongTopic();
      this.backTop();
    },
    /* 重新答题 */
    resetSubmit() {
      this.subLoading = false;
      this.isSubmit = false;
      this.getUserWrongTopic();
      this.backTop();
    },
    // 回到顶部
    backTop() {
      window.scrollTo(0, 0);
    },
    // 播放视频
    playVideo(ite) {
      this.videoShow = true;
      if (ite.playbackClientCode == 1) {
        // cc直播回放视频
        this.isCc = true;
      } else {
        // 录播视频
        this.isCc = false;
      }
      setTimeout(() => {
        if (this.isCc) {
          this.ccPlayerRef && this.ccPlayerRef.init(ite);
        } else {
          this.videoInfo = ite;
        }
      }, 0);
    },
    // 视频关闭
    videoClose() {
      this.videoShow = false;
      this.videoInfo = {};
      this.isCc = false;
    }
  }
};
</script>

<style lang="less" scoped>
.question-con {
  padding: 24px;
  margin-top: 15px;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.08);

  .showError {
    margin: 0 0 15px 25px;
    color: #333333;
    font-size: 16px;

    .tag1 {
      font-size: 20px;
      font-weight: bold;
      color: #007efb;
    }

    .tag2 {
      font-size: 20px;
      font-weight: bold;
      color: #ef4114;
    }

    .tag3 {
      font-size: 20px;
      font-weight: bold;
      color: #19e3a2;
    }
  }
}

.btn-con {
  margin: 26px 0 15px 0;
  padding-left: 217px;
  display: flex;

  .el-button {
    margin-right: 86px;
    color: #777777;
    width: 176px;
    height: 47px;
    text-align: center;
    // line-height: 47px;
    font-size: 16px;
    border-radius: 8px;
    font-weight: bold;
  }

  .reset-btn {
    color: #3366ff;
    border: 1px solid #3366ff;
  }

  .go-btn {
    color: #fff;
    background: #3366ff;
  }
}

.search-con {
  padding: 20px 0;
  display: flex;

  /deep/ .el-select {
    margin-right: 20px;
    width: 245px;
    height: 43px;

    .el-input__wrapper {
      height: 43px;
      background-color: #f7f6f9;
      box-shadow: none !important;
    }
  }

  .el-select:last-child {
    margin-right: 0;
  }

  .on-course {
    padding: 0 16px;
    color: #aaaaaa;
    font-size: 14px;
    width: 341px;
    height: 43px;
    background: #f7f6f9;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.player-main {
  width: 100%;
  height: 495px;
  position: relative;
  background: #2e2e2e;
}
</style>
